const BackgroundColor = {
    issue: 'lightGreen.light',
    organization: 'red.light',
    member: 'blue.light',
    Bug: 'error.light',       // red-ish background for Bug
    Task: 'primary.light',    // blue-ish background for Task
    Subtask: 'success.light', // green-ish background for Subtask

    project: 'orange.light',
    comment: 'pink.light',
};
const Color = {
        Bug: 'error.dark',        // dark red text for Bug
    Task: 'primary.dark',     // dark blue text for Task
    Subtask: 'success.dark',  // dark green text for Subtask

    issue: 'lightGreen.dark',
    organization: 'red.dark',
    member: 'blue.dark',
    label: 'yellow.dark',
    project: 'orange.dark',
    comment: 'pink.dark',
};

const IssueType = {
    Bug: 'bug.png',
    Task: 'Task.png',
    Subtask: 'subTask.png',
};

const Priority = {
    Low: 'low.png',
    Lowest: 'lowest.png',
    Medium: 'medium.png',
    High: 'high.png',
    Highest: 'highest.png',
};

const PriorityColor = {
    Low: 'blue.dark',
    Lowest: 'blue.dark',
    Medium: 'yellow.dark',
    High: 'red.dark',
    Highest: 'red.dark',
};

const projectsImg = [
    'projects/project1.svg',
    'projects/project2.svg',
    'projects/project3.svg',
    'projects/project4.svg',
    'projects/project5.svg',
    'projects/project6.svg',
    'projects/project7.svg',
    'projects/project8.svg',
    'projects/project9.svg',
    'projects/project10.svg',
    'projects/project11.svg',
    'projects/project12.svg',
    'projects/project13.svg',
    'projects/project4.svg',
    'projects/project15.svg',
    'projects/project16.svg',
    'projects/project17.svg',
    'projects/project18.svg',
    'projects/project19.svg',
    'projects/project20.svg',
    'projects/project21.svg',
    'projects/project22.svg',
    'projects/project23.svg',
    'projects/project24.svg',
    'projects/project25.svg',
];

const BackgroundColorYourWork = [
    '#5D1F1A',
    '#164555',
    '#09326C',

    '#352C63',
    '#164555',
];
export {
    Color,
    BackgroundColor,
    IssueType,
    Priority,
    PriorityColor,
    projectsImg,
    BackgroundColorYourWork,
};
